import { MOCK_PROFILES } from './constants';
import {
  loadMockState,
  createTenant,
  updateTenantAllowedSectionsForAdmCliente,
  addSector,
  renameSector,
  deleteSector,
  updateUserAllowedSections,
  createAdmCliente,
  createCompanyWithAdmCliente,
  deleteTenant,
  createCommonUser,
  setSession,
  setSessionEmail,
  resetMockState,
} from './store';

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
const randomLatency = () => 250 + Math.floor(Math.random() * 450);

export const mock = {
  async getState() {
    await sleep(50);
    return loadMockState();
  },

  async reset() {
    await sleep(80);
    return resetMockState();
  },

  async setSession(payload) {
    await sleep(80);
    return setSession(payload);
  },

  async setSessionEmail(payload) {
    await sleep(50);
    return setSessionEmail(payload);
  },

  async me() {
    await sleep(120);
    const state = loadMockState();
    const { profile } = state.session;
    const tenant = state.tenants.find((t) => t.id === state.session.tenantId);
    const tenantName = tenant?.name || 'Empresa';
    const sessionEmail = (state.session.email || '').trim();
    const effectiveUser =
      profile === MOCK_PROFILES.USER_CLIENTE
        ? (tenant?.users || []).find((u) => String(u.email || '').trim().toLowerCase() === sessionEmail.toLowerCase() && u.type === MOCK_PROFILES.USER_CLIENTE)
          || (tenant?.users || []).find((u) => u.type === MOCK_PROFILES.USER_CLIENTE)
        : null;
    const allowedSectionKeys =
      profile === MOCK_PROFILES.ADM_WES
        ? ['dashboard', 'automation', 'infrastructure', 'integrations', 'storage', 'administration', 'processes']
        : profile === MOCK_PROFILES.ADM_CLIENTE
          ? (tenant?.allowedSectionsForAdmCliente || [])
          : (effectiveUser?.allowedSectionsForUser || []);
    const base = {
      user_id: 'mock-user',
      email:
        profile === MOCK_PROFILES.ADM_WES
          ? (sessionEmail || 'admin@1wes.com')
          : profile === MOCK_PROFILES.ADM_CLIENTE
            ? (sessionEmail || 'adm.cliente@empresa.com')
            : (sessionEmail || 'user@empresa.com'),
      full_name:
        profile === MOCK_PROFILES.ADM_WES
          ? 'ADM WES'
          : profile === MOCK_PROFILES.ADM_CLIENTE
            ? 'ADM Cliente'
            : 'Usuário Comum',
      tenant_id: state.session.tenantId,
      tenant_name: tenantName,
      roles: profile === MOCK_PROFILES.ADM_CLIENTE ? ['admin'] : profile === MOCK_PROFILES.USER_CLIENTE ? ['user'] : [],
      platform_roles: profile === MOCK_PROFILES.ADM_WES ? ['admin_wes'] : [],
      permissions: [],
      profile_type: profile,
      allowed_section_keys: allowedSectionKeys,
    };
    return base;
  },

  async listTenants() {
    await sleep(randomLatency());
    const state = loadMockState();
    return state.tenants;
  },

  async createTenant(payload) {
    await sleep(randomLatency());
    return createTenant(payload);
  },

  async updateTenantAllowedSectionsForAdmCliente(payload) {
    await sleep(randomLatency());
    return updateTenantAllowedSectionsForAdmCliente(payload);
  },

  async addSector(payload) {
    await sleep(randomLatency());
    return addSector(payload);
  },

  async renameSector(payload) {
    await sleep(randomLatency());
    return renameSector(payload);
  },

  async deleteSector(payload) {
    await sleep(randomLatency());
    return deleteSector(payload);
  },

  async updateUserAllowedSections(payload) {
    await sleep(randomLatency());
    return updateUserAllowedSections(payload);
  },

  async createAdmCliente(payload) {
    await sleep(randomLatency());
    return createAdmCliente(payload);
  },

  async createCompanyWithAdmCliente(payload) {
    await sleep(randomLatency());
    return createCompanyWithAdmCliente(payload);
  },

  async deleteTenant(payload) {
    await sleep(randomLatency());
    return deleteTenant(payload);
  },

  async listAccessibleTenants() {
    await sleep(120);
    const state = loadMockState();
    const { profile } = state.session || {};
    const sessionEmail = String(state.session?.email || '').trim().toLowerCase();

    const all = state.tenants || [];
    if (profile === MOCK_PROFILES.ADM_WES) return all;

    // For ADM Cliente / User comum: show only the tenant where their email exists.
    const match = all.find((t) =>
      (t.users || []).some((u) => String(u.email || '').trim().toLowerCase() === sessionEmail)
    );
    return match ? [match] : [];
  },

  async createCommonUser(payload) {
    await sleep(randomLatency());
    return createCommonUser(payload);
  },
};
